/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {useThemeMode} from '../../../../../../_metronic/partials';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import css from '../../../../../../styles/TOPManagers.module.scss';
import InputSearch from '../../../../../shared/InputSearch';
import Item from './Item';
import {SelectorIsMulti} from '../../../../../shared/Selectors';

const WORKSPACES_PLACEHOLDER = '\u0412\u043e\u0440\u043a\u0441\u043f\u0435\u0439\u0441\u044b';

const workspaceSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: '43px',
    height: '43px',
    border: '0',
    boxShadow: 'none',
    backgroundColor: 'var(--bs-gray-100)',
    borderRadius: '0.475rem',
    fontSize: '1.1rem',
    fontWeight: 500,
  }),
  valueContainer: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    height: '43px',
    padding: '0 10px',
    gap: '4px',
    overflow: 'hidden',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '43px',
  }),
  placeholder: (base) => ({
    ...base,
    margin: 0,
    color: 'var(--bs-text-gray-500)',
    fontSize: '1.1rem',
    fontWeight: 500,
  }),
  input: (base) => ({
    ...base,
    color: 'var(--bs-text-gray-700)',
    fontSize: '1.1rem',
    fontWeight: 500,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'var(--bs-text-gray-500)',
    padding: '8px 12px',
    ':hover': {
      color: 'var(--bs-primary)',
    },
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: 'var(--bs-gray-300)',
    marginTop: '8px',
    marginBottom: '8px',
  }),
  multiValue: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    minHeight: '28px',
    margin: 0,
    backgroundColor: 'var(--bs-gray-200)',
    border: '0',
    borderRadius: '0.475rem',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'var(--bs-text-gray-700)',
    fontSize: '1.05rem',
    fontWeight: 500,
    padding: '3px 6px 3px 8px',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--bs-text-gray-500)',
    padding: '0 6px',
    borderRadius: '0 0.475rem 0.475rem 0',
    ':hover': {
      backgroundColor: 'var(--bs-gray-300)',
      color: 'var(--bs-text-gray-700)',
    },
  }),
};

const List = ({data, withoutOutsiders, workspaceOptions, selectedWorkspaces, setSelectedWorkspaces}) => {
  const store = useStore();
  const theme = useThemeMode();

  const [mode, setMode] = useState('');
  const [list, setList] = useState();
  const [searchUser, setSearchUser] = useState([]);
  const [top, setTop] = useState([]);
  const [bad, setBad] = useState([]);
  const [outsidersIds, setOutsidersIds] = useState([]);

  const sortByPlaceAsc = (items) => {
    return [...items].sort((a, b) => {
      if (a.place === 99999 && b.place !== 99999) return 1;
      if (b.place === 99999 && a.place !== 99999) return -1;
      return a.place - b.place;
    });
  };

  const sortByPlaceDesc = (items) => {
    return [...items].sort((a, b) => {
      if (a.place === 99999 && b.place !== 99999) return 1;
      if (b.place === 99999 && a.place !== 99999) return -1;
      return b.place - a.place;
    });
  };

  useEffect(() => {
    if (theme.mode === 'system') {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        setMode('dark');
      } else {
        setMode('light');
      }
    } else {
      setMode(theme.mode);
    }
  }, [theme]);

  useEffect(() => {
    const eligibleList = withoutOutsiders || [];

    if (eligibleList.length <= 3) {
      setList(data);
      setSearchUser(data);
      setBad([]);
      return setTop(eligibleList.map((obj) => obj?.id));
    }

    const cut = eligibleList?.length === 4 ? -1 : eligibleList?.length === 5 ? -2 : -3;

    const minObjects = eligibleList.slice(0, 3);
    const maxObjects = eligibleList.slice(cut);

    const minIds = minObjects.map((obj) => obj?.id);
    const maxIds = maxObjects.map((obj) => obj?.id);

    setTop(minIds);
    setBad(maxIds);

    setList(data);
    setSearchUser(data);
  }, [data]);

  return (
    <div className={css.container}>
      <section className={css.header}>
        <InputSearch
          title={'\u041f\u043e\u0438\u0441\u043a...'}
          array={list}
          newArray={setSearchUser}
          searchParameters={['id', 'full_name']}
        />
        <div className={css.workspaceFilter}>
          <SelectorIsMulti
            placeholder={WORKSPACES_PLACEHOLDER}
            options={workspaceOptions}
            value={selectedWorkspaces}
            onChange={(value) => setSelectedWorkspaces(value || [])}
            styles={workspaceSelectStyles}
          />
        </div>
        <div className='text-end mb-5 mb-sm-5 mb-md-0' style={{marginLeft: '20px'}}>
          <button
            type='button'
            className='btn fw-bold btn-light btn-color-muted btn-active-light-primary text-nowrap cursor-pointer'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
          >
            <span>{'\u0420\u0435\u0439\u0442\u0438\u043d\u0433'}</span>{' '}
            <i className='ki-duotone ki-down fs-5 ms-1'></i>
          </button>
          <div
            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-150px py-4'
            data-kt-menu='true'
          >
            <div className='menu-item px-3'>
              <span
                className='menu-link px-3'
                onClick={() => {
                  const sort = sortByPlaceAsc(list);
                  setSearchUser([...sort]);
                }}
              >
                {'\u0421\u043d\u0430\u0447\u0430\u043b\u0430 \u043b\u0443\u0447\u0448\u0438\u0435'}
              </span>
            </div>
            <div className='menu-item px-3'>
              <span
                className='menu-link px-3'
                data-kt-users-table-filter='delete_row'
                onClick={() => {
                  const sort = sortByPlaceDesc(list);
                  setSearchUser([...sort]);
                }}
              >
                {'\u0421\u043d\u0430\u0447\u0430\u043b\u0430 \u0445\u0443\u0434\u0448\u0438\u0435'}
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className={css.listContainer}>
        <ul className={css.list}>
          {searchUser?.map((el) => {
            return (
              <React.Fragment key={`${el.id}`}>
                <Item data={el} top={top} bad={bad} />
              </React.Fragment>
            );
          })}
        </ul>
      </section>
    </div>
  );
};

export default observer(List);
